import {
  ThemeProvider,
  SignalRProvider,
  UpdateListener,
} from "@radianse/components";
import { refreshAccessToken } from "./apiConfig";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { GroupsProvider, UserProvider } from "./context";
import { ApiAuthProvider, ApiAuthContext } from "./context/ApiAuthContext";
import { AppInsightsErrorBoundary } from "./common/AppInsightsErrorBoundary";
import Loader from "./common/Loader";
import { name as appName } from "../package.json";
import { NetworkStatus } from "./common/NetworkStatus";

import "./i18n";

const Index = () => {
  return (
    <ThemeProvider>
      <NetworkStatus>
        <AppInsightsErrorBoundary>
          <ApiAuthProvider>
            <SignalRProvider
              context={ApiAuthContext}
              server={window["_env"].SIGNALR_API}
              tokenFactory={refreshAccessToken}
            >
              <UserProvider>
                <GroupsProvider>
                  <BrowserRouter>
                    <Suspense fallback={<Loader />}>
                      <UpdateListener appName={appName} />
                      <App />
                    </Suspense>
                  </BrowserRouter>
                </GroupsProvider>
              </UserProvider>
            </SignalRProvider>
          </ApiAuthProvider>
        </AppInsightsErrorBoundary>
      </NetworkStatus>
    </ThemeProvider>
  );
};

if (process.env.NODE_ENV === "development") {
  (async () => {
    const { default: startWorker } = await import("./mockData/startWorker");
    startWorker();
    ReactDOM.render(<Index />, document.getElementById("root"));
  })();
} else {
  ReactDOM.render(<Index />, document.getElementById("root"));
}
